import { render } from "./PaymentRecordReview.vue?vue&type=template&id=46587752&scoped=true"
import script from "./PaymentRecordReview.vue?vue&type=script&lang=js"
export * from "./PaymentRecordReview.vue?vue&type=script&lang=js"

import "./PaymentRecordReview.vue?vue&type=style&index=0&id=46587752&scoped=true&lang=css"
import "./PaymentRecordReview.vue?vue&type=style&index=1&id=46587752&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46587752"]])

export default __exports__